import Api from '@/api/Api'
import store from '../store'

export default {

  async verifySend (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('email/verify/send', data, options))
  },

  async verifyCheck (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('email/verify/check', data, options))
  },

  async forgotPasswordSend (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('email/forgot/password/send', data, options))
  },

  async forgotPasswordCheck (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('email/forgot/password/check', data, options))
  },

}



// WEBPACK FOOTER //
// ./src/api/MailService.js